export const COMPANY_COUNTRY_NAME_BRAZIL = 'Brazil'
